import React from 'react';
import { array, objectOf, string } from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import Icon from 'yoda-core-components/lib/components/Icon';
import Check from 'yoda-core-components/lib/assets/svg/Check.svg';
import Close from 'yoda-core-components/lib/assets/svg/Close.svg';
import Mouse from 'yoda-core-components/lib/assets/svg/Mouse.svg';
import Warning from 'yoda-core-components/lib/assets/svg/Warning.svg';
import config from '../../ProductCard.config';
import styles from './ProductAvailability.css';

const cx = classNames.bind(styles);

export const ProductAvailability = (props) => {
    const {
        deviceType: { isDesktop },
        cardType,
        featureFlags: { enableProductAvailability } = {},
        availabilityStatus,
    } = props;

    const displayProductAvailability =
        enableProductAvailability && // Feature flag for Product Availability
        cardType === config.cardTypes.GRID && // Display Product Availability only in GRID view
        isDesktop &&
        availabilityStatus &&
        availabilityStatus.length; // Availability status info

    if (displayProductAvailability) {
        const availability = [];
        const iconMap = {
            mouse: <Mouse />,
            cross: <Close />,
            warning: <Warning />,
        };

        const messageClasses = [
            'font-open-sans-semibold',
            'text-gray-600 text-xsmall',
            cx('product-availability-message'),
        ].join(' ');

        for (let i = 0; i < availabilityStatus.length; i += 1) {
            let { storeName } = availabilityStatus[i];

            if (storeName && storeName.length > 19) {
                storeName = `${storeName.slice(0, 19)}...`;
            }

            const uniqueKey = Math.floor(Math.random() * 100);
            const content = (
                <div className="flex" key={uniqueKey}>
                    <Icon automationId="check-automation-swatch" height="24" width="24">
                        {iconMap[availabilityStatus[i].icon] || <Check />}
                    </Icon>
                    <div className="ml-1 mt-1">
                        {/* eslint-disable react/no-danger */}
                        <div
                            className={messageClasses}
                            dangerouslySetInnerHTML={{ __html: availabilityStatus[i].message }}
                        />
                        {storeName ? <div>{storeName}</div> : null}
                    </div>
                </div>
            );
            availability.push(content);
        }

        return <>{availability}</>;
    }

    return null;
};

ProductAvailability.defaultProps = {
    deviceType: objectOf.isRequired,
    cardType: string,
    featureFlags: objectOf,
    availabilityStatus: array,
};

ProductAvailability.propTypes = {
    deviceType: {},
    cardType: '',
    featureFlags: {},
    availabilityStatus: [],
};

/* istanbul ignore next */
const mapStateToProps = ({ context }) => ({
    featureFlags: context ? context.featureFlags : {},
});

export default connect(mapStateToProps)(ProductAvailability);
